<template>
  <div :class="classList" :data-id="_uid" @click="toggle">
    <div class="a-label__icon" v-if="icon">
      <slot name="icon"></slot>
    </div>
    <div class="a-label__text">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VLabel',
  introduction: 'A small badge with text and an icon.',
  props: {
    type: {
      type: String,
      required: true,
      note: 'The styling type ("error", "success" etc.).',
    },
    icon: {
      type: Boolean,
      default: false,
      note: 'Toggles to show the icon slot. Unnecessary Should be removed.',
    },
    size: {
      type: String,
      default: 'small',
      note: 'Sets the size of the element, by default this is "small" but can be "medium".',
    },
    toggleable: {
      type: Boolean,
      default: false,
      note: 'Sets the cursor to a pointer. Probably not needed needs review.',
    },
    subtype: {
      type: String,
      note: 'Style as "outlined" or "basic".',
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    classList() {
      const {
        type, subtype, size, icon, toggleable, active,
      } = this;
      return {
        'a-label': true,
        'a-label--icon': icon,
        'a-label--toggleable': toggleable,
        'a-label--active': active,
        [`a-label--${size}`]: size,
        [`a-label--${type}`]: type,
        [`a-label--${subtype}`]: subtype,
      };
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
  },
};
</script>

<style scoped>
.a-label {
  --icon-width-outlined: 20px;
  padding: var(--spacing-xs) var(--spacing-small);
  border-radius: 15px;
  color: #fff;
  position: relative;
  width: auto;
  float: left;
  font-weight: 600;
  margin-bottom: var(--spacing-xs);
  margin-left: var(--spacing-small);
  /* The label should probably not know about draft / sent etc.*/
  /* The color should probably be passed in as a prop or using parent styling*/
}

.a-label:after {
  content: '';
  display: block;
  clear: both;
}

.a-label:first-child {
  margin-left: 0;
}

.a-label__text {
  font-size: var(--font-size-xs);
  float: left;
}

.a-label__icon {
  position: absolute;
  transform: translate3d(0, -50%, 0);
  top: 50%;
}

.a-label.a-label--toggleable {
  cursor: pointer;
}

.a-label--info {
  background: var(--color-info);
  border-color: var(--color-info-dark);
}

.a-label--info .a-label__icon {
  background: var(--color-info-dark);
}

.a-label--purple {
  background: var(--signable-secondary-1-shade-2);
  border-color: var(--signable-secondary-1);
}

.a-label--purple .a-label__icon {
  background: var(--signable-secondary-1);
}

.a-label--success {
  background: var(--color-success);
  border-color: var(--color-success-dark);
}

.a-label--success .a-label__icon {
  background: var(--color-success-dark);
}

.a-label--warning {
  background: var(--color-warning);
  border-color: var(--color-warning-dark);
}

.a-label--warning .a-label__icon {
  background: var(--color-warning-dark);
}

.a-label--error {
  background: var(--color-error);
  border-color: var(--color-error-dark);
}

.a-label--error .a-label__icon {
  background: var(--color-error-dark);
}

.a-label--outlined {
  padding: var(--spacing-xs);
  background: #fff;
  border-radius: 3px;
  border: 1px solid;
}

.a-label--outlined .a-label__icon {
  width: var(--icon-width-outlined);
  border-radius: 0;
  background: #fff;
}

.a-label--outlined .a-label__icon svg {
  width: 12px;
  height: 12px;
}

.a-label--outlined.a-label--icon .a-label__text {
  margin-left: calc(var(--icon-width-outlined) - var(--spacing-xs));
}

.a-label--outlined.a-label--purple {
  color: var(--signable-secondary-1);
}

.a-label--outlined.a-label--purple:hover {
  background: var(--signable-secondary-1-shade-3);
}

.a-label--outlined.a-label--purple.a-label--active {
  background: var(--signable-secondary-1);
  color: #fff;
}

.a-label--outlined.a-label--info {
  color: var(--color-info);
}

.a-label--outlined.a-label--success {
  color: var(--color-success);
}

.a-label--outlined.a-label--warning {
  color: var(--color-warning);
}

.a-label--outlined.a-label--error {
  color: var(--color-error);
}

.a-label--basic {
  padding: 0;
  background: #fff;
  border: 0;
  border-radius: 0;
  font-size: var(--font-size-xs);
}

.a-label--basic .a-label__icon {
  background: transparent;
}

.a-label--basic .a-label__icon svg {
  height: 16px;
  width: 16px;
}

.a-label--basic .a-label__text {
  margin-left: 0;
  padding-left: var(--spacing-large);
}

.a-label--basic.a-label--info .a-label__icon,
.a-label--basic.a-label--info .a-label__text {
  color: var(--color-info);
}

.a-label--basic.a-label--success .a-label__icon,
.a-label--basic.a-label--success .a-label__text {
  color: var(--color-success);
}

.a-label--basic.a-label--warning .a-label__icon,
.a-label--basic.a-label--warning .a-label__text {
  color: var(--color-warning);
}

.a-label--basic.a-label--error .a-label__icon,
.a-label--basic.a-label--error .a-label__text {
  color: var(--color-error);
}

.a-label--draft {
  background-color: var(--signable-secondary-3);
}

.a-label--sent {
  background-color: var(--signable-primary-1);
}

.a-label--signed {
  background-color: var(--color-success);
}

.a-label--rejected {
  background-color: var(--color-error);
}

.a-label--expired {
  background-color: var(--signable-secondary-3-shade-2);
}

.a-label--cancelled {
  background-color: var(--color-error-dark);
}

.a-label--verify {
  background-color: var(--signable-primary-1);
}

.a-label--unverified {
  background-color: var(--signable-primary-1);
}

.a-label--medium {
  padding: var(--spacing-xs) var(--spacing-small);
  margin-right: var(--spacing-small);
}

.a-label--medium .a-label__text {
  font-size: 14px;
}
</style>
